export const brandPrimary = "#1c2b35";
export const brandSecondary = "#43c1c3";
export const backdrop = "#e8ebed";

export const brandBlue = "#223240";
export const brandLightBlue = "#82949e";
export const brandGray = "#a8b6be";

export const darkGray = "#666";
export const lightGray = "rgb(0,0,0,0.5)";
export const lighterGray = "#e1e1e1";
export const white = "#ffffff";

export const dirtyInputLight = "#f7f197";
export const dirtyInputDark = "#DCB34C";

export const warning = "rgb(237, 153, 80)";
export const error = "rgb(237, 80, 80)";
export const errorDarkTheme = "#FFCDD2";

export const divider = "#e4e4e4";
export const dividerDark = "rgb(45, 45, 45)";
